import { SortableItemContainerComponent } from "@/Common/Components/Collections/SortableItemContainer";
import { MedicalItemImmunization } from "@/Patient/Models/MedicalSummary/MedicalItemImmunization";

class SortableContainerForImmunizations extends SortableItemContainerComponent<MedicalItemImmunization> { }

export { SortableContainerForImmunizations };
